<app-toolbar></app-toolbar>
<div id="wrapper-content" class="p-t-9 d-f f-d">
    <main role="main" class="f-a">
        <router-outlet></router-outlet>
    </main>
</div>
<app-footer></app-footer>